import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import "./PouPrint.css"
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import {BsGlobe, BsHouse, BsMailbox, BsTelephoneForward} from "react-icons/bs";
import {FcPrint} from "react-icons/all";


class ComponentToPrint extends Component {
    constructor(props) {
        console.log(props.data)
        // console.log(props.data.surname)
        super(props);
    }

    render() {
        return (
            <div>

                <div className="container-pou"
                     style={{
                         width: "100vw",
                         height: "100vh",
                         maxHeight: "100vh",
                         margin: '10mm',
                         padding: "0",
                         overflow: "absolute!important",
                     }}
                >
                    <div>

                        <div className="company-main-info"
                        >
                            <Row>
                                <Col className="col-md-3" style={{
                                    padding: "1rem",
                                    maxWidth: '45vw',
                                    maxHeight: "100vh",
                                }}>
                                    <Row className="kartka">
                                        <img
                                            className="col imagepou"
                                            src={this.props.data.pou_image}
                                            alt="imagepou"
                                            loading="lazy"/>

                                        <div
                                            className="cart-company-lg__box">Юридична назва

                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">{this.props.data.pou_nazva_minust}
                                        </div>
                                        <div
                                            className="cart-company-lg__box">код
                                            ЄДРПОУ
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">{this.props.data.pou_edrpou}
                                        </div>
                                        <div
                                            className="cart-company-lg__box">Керівник
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">{this.props.data.pou_chef}
                                        </div>
                                        <div
                                            className="cart-company-lg__box"><BsHouse style={{
                                            color: "darkred"
                                        }}/> Юридична/Поштова
                                            адреса
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">{this.props.data.adres_ur}
                                        </div>
                                        <div
                                            className="cart-company-lg__box"><BsHouse style={{
                                            color: "darkred"
                                        }}/> Фактична
                                            адреса
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint"> {this.props.data.adres_fact}
                                        </div>

                                        <div
                                            className="cart-company-lg__box"><BsTelephoneForward
                                            style={{
                                                color: "darkred"
                                            }}/> Телефон
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">{this.props.data.pou_contact}

                                        </div>

                                        <div
                                            className="cart-company-lg__box"><BsMailbox style={{
                                            color: "darkred"
                                        }}/> E-mail
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint">
                                            <a
                                                href='mailto:${pou.adres_mail}'
                                                target="_blank">{this.props.data.adres_mail}</a>
                                        </div>

                                        <div
                                            className="cart-company-lg__box"><BsGlobe style={{
                                            color: "darkred"
                                        }}/> Сайт
                                        </div>
                                        <div
                                            className="cart-company-lg__list-linkprint" style={{
                                            paddingRight: "2"
                                        }}>
                                            <a
                                                href={this.props.data.adres_web}
                                                rel="nofollow"
                                                target="_blank">{this.props.data.adres_web}</a>
                                        </div>

                                    </Row>
                                </Col>

                                <Col className="col-md-10 telo" style={{
                                   paddingLeft: "2rem",
                                    //maxWidth: '65vw',
                                    maxHeight: "100vh",
                                }}>
                                    <Row>
                                        <Col md={4}/>

                                        <Col md={8}>
                                            <div style={{
                                                backgroundColor: "black",
                                                clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                                width: "4rem",
                                                marginLeft: "4rem"
                                            }}>""
                                            </div>
                                            <div

                                                className="cart-company-lg__kved ">{this.props.data.pou_kved}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Row style={{
                                            height:"10vh"
                                        }}>
                                            <div
                                                className="cart-company-lg__title "
                                                dangerouslySetInnerHTML={{__html: this.props.data.pou_nazva.toUpperCase()}}/>
                                            <div
                                                className="cart-company-lg__content"
                                                dangerouslySetInnerHTML={{__html: this.props.data.pou_content}}/>
                                            <Row style={{
                                                marginLeft: "2rem",
                                                marginRight: "3%",
                                                paddingLeft: "1rem", paddingRight: "2rem"
                                            }}>
                                                <Col auto><img
                                                    className="insideprint "
                                                    src={this.props.data.product_image[0].original}
                                                    alt=""
                                                    loading="lazy"/></Col>
                                                <Col auto><img
                                                    className="insideprint"
                                                    src={this.props.data.product_image[1].original}
                                                    alt=""
                                                    loading="lazy"/></Col>
                                            </Row>
                                            <Row style={{
                                                marginBottom: '1rem',
                                                marginLeft: "1rem",
                                                marginRight: "1rem",
                                                paddingLeft: "3%",
                                                paddingRight: "5%",

                                            }}>
                                                <Col><img
                                                    className="insideprint"
                                                    src={this.props.data.product_image[2].original}
                                                    alt=""
                                                    style={{
                                                        float: 'center',
                                                        maxHeight: "10rem",
                                                        marginLeft: "30%",
                                                        marginRight: "50%"
                                                    }}
                                                    loading="lazy"/></Col>
                                            </Row>

                                            <div
                                                className="cart-company-lg__product">ТОВАРИ ТА ПОСЛУГИ
                                            </div>
                                            <ul className="cart-company-lg__content">
                                                <li dangerouslySetInnerHTML={{__html: this.props.data.product_nazva}}/>

                                            </ul>
                                        </Row>

                                    </Row>
                                </Col>

                            </Row>
                        </div>
                    </div>
                </div>
                <div>

                </div>


            </div>

        );
    }
}

export default class ModulDetail extends React.Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.state = {
            detail: this.props.data
        }
    }

    render() {
        return (
            <div>
                <ReactToPrint
                    trigger={() => <a href="#"> <Button
                        style={{marginLeft: "70%", marginBottom: "0.2rem"}}><FcPrint style={{
                        width:"2rem",height:"2rem"
                    }}/>Роздрукувати
                    </Button></a>}
                    pageStyle='@media print {
  html, body {
    height: initial !important;
    overflow: absolute !important;
    -webkit-print-color-adjust: exact;
  }
}'
                    content={() => this.componentRef}
                />
                < div style={{display: " none "}}><ComponentToPrint ref={(el) => (this.componentRef = el)}
                                                                    data={this.state.detail}>

                </ComponentToPrint></div>
            </div>
        );
    }
}


